import { css } from 'linaria';
import { styled } from 'linaria/react';

export const previewWrapper = css`
  margin-right: 32px;

  @media (--only-desktop) {
    margin-right: 20px;
  }

  @media (--to-desktop) {
    display: none;
  }
`;

export const previewWrapperWithoutChevron = css`
  @media (--only-largeDesktop) {
    margin-top: 40px;
  }

  @media (--only-desktop) {
    margin-top: 38px;
  }
`;

export const ChevronIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  border-radius: var(--rounding-l);
  cursor: pointer;

  @media (--only-desktop) {
    height: 30px;
  }

  &:hover {
    background-color: var(--control-hover-minor);
  }

  &:first-of-type {
    margin-bottom: 8px;
  }
`;

export const chevronIconHidden = css`
  visibility: hidden;
`;

export const previewSwiper = css`
  width: 64px;
  height: 288px;

  @media (--only-desktop) {
    width: 60px;
    height: 272px;
  }

  .swiper-button-prev {
    top: 0;
  }

  .swiper-button-next {
    bottom: 0;
  }
`;

export const previewSlide = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin-bottom: 8px;
    border: 1px solid var(--control-secondary);
    border-radius: var(--rounding-m);
    cursor: pointer;

    @media (--only-desktop) {
      width: 60px;
      height: 60px;
    }
  }
`;

export const activePreviewSlide = css`
  &&& {
    border: 2px solid var(--control-accent);
    opacity: 1;
  }
`;
